export default __webpack_public_path__ + "static/media/Wallpaper-2.f5dc48c3.jpg";